module.exports = __webpack_public_path__ + "img/logo-qt_3fb4051768a91ddc1d2e93c3fc244cf7.longcache.png";